export const serviceAreaIconTokens = [
    'arrowRight',
    'badgeCheck',
    'building',
    'calendar',
    'checkCircle',
    'drawers',
    'house',
    'layers',
    'mapPin',
    'palette',
    'phone',
    'ruler',
    'sliding',
    'sparkles',
    'tools',
    'users',
    'wardrobe',
    'waves',
] as const;

export type ServiceAreaIconToken = (typeof serviceAreaIconTokens)[number];

export const serviceAreaTokens = {
    colors: {
        background: '#ffffff',
        surface: '#ffffff',
        surfaceSoft: '#f7f9fc',
        text: '#07142f',
        textSoft: '#34415a',
        textMuted: '#667085',
        accent: '#1769ff',
        accentDark: '#0f4fd1',
        accentSoft: '#eef4ff',
        accentContrast: '#ffffff',
        action: '#ff6900',
        actionDark: '#df5800',
        actionContrast: '#ffffff',
        border: 'rgba(7, 20, 47, 0.1)',
        borderStrong: 'rgba(7, 20, 47, 0.16)',
        success: '#16834a',
        mapBackground: '#eaf5fb',
        ctaBackground: '#071a38',
        ctaText: '#ffffff',
        shadow: '0 18px 44px rgba(7, 20, 47, 0.08)',
        softShadow: '0 10px 26px rgba(7, 20, 47, 0.08)',
    },
    radius: {
        shell: 12,
        card: 10,
        media: 10,
        button: 8,
        pill: 999,
    },
    sizes: {
        maxWidth: 1220,
        heroMediaMinHeight: 430,
        mapMinHeight: 500,
    },
    spacing: {
        sectionX: 24,
        sectionY: 34,
        shellX: 18,
        blockGap: 28,
    },
    typography: {
        fontFamily:
            'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
        title: {
            fontSize: 50,
            tabletFontSize: 43,
            mobileFontSize: 34,
            lineHeight: 1.02,
            fontWeight: 900,
        },
        sectionTitle: {
            fontSize: 24,
            mobileFontSize: 21,
            lineHeight: 1.12,
            fontWeight: 900,
        },
        body: {
            fontSize: 16,
            mobileFontSize: 15,
            lineHeight: 1.58,
            fontWeight: 500,
        },
    },
    defaults: {
        pageTypeLabel: 'Service area',
        insightsEyebrow: 'Area insights',
        solutionsTitle: 'Recommended solutions',
        finishesTitle: 'Popular finishes',
        processTitle: 'How it works',
        nearbyAreasTitle: 'We also service nearby areas',
        postcodeLabel: 'Postcode',
        apartmentsLabel: 'Apartments',
        housesLabel: 'Houses',
        townhousesLabel: 'Townhouses',
        snapshotLabel: 'Dwelling snapshot',
        regionLabel: 'Region',
    },
} as const;

export type ServiceAreaColorToken = keyof typeof serviceAreaTokens.colors;
